
export default {
  namespaced: true,
  state: {
    periodos: [],
    error: "",
  },
  mutations: {
    "SET_PERIODOS"(state, payload) {
      state.periodos = payload
    },
    "SET_ERROR"(state, payload) {
      state.error = payload
    }
  },
  actions: {
    getPeriodos({commit}) {
      this._vm.$axios.get("/finanzas/consolidado-ventas/periodos")
        .then(response => {
          commit("SET_PERIODOS", response.data.items)
        })
        .catch(e => {
          commit("SET_ERROR", e)
          console.log(e)
        })
    }
  },
  getters: {
    periodos: state => state.periodos,
    dataPeriodo: state => state.dataPeriodo
  }
}
